import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Question from '../Question/Question';

const Quiz = () => {
    const topicAllData = useLoaderData();
   
    const {  name,  questions } = topicAllData.data;
    return (
        <div>
            <h2 className='text-2xl font-bold bg-blue-200 rounded w-fit mx-auto px-24 py-4 my-4 text-blue-800 border-2 border-blue-800'>Quiz of {name}</h2>
            <div className='py-12 grid sm:grid-cols-1 md:grid-cols-2 gap-1 gap-y-4'>
                {questions.map((question,index) => <Question key={question.id} questionData={question} index={index} />)}
            </div>
        </div>
    );
};

export default Quiz;